import { pinAMapPosition, MapGeographicPosition, Layer, LayerType, LayerElevationLoadStatus } from '/@/types/map'
import { generatePoint, generateLine, generatePolygon, generateCircle } from '/@/utils/genjson'
import { MapDoodleColor, MapElementEnum } from '/@/constants/map'

function getPinPosition (pos: pinAMapPosition, elevation = 0): MapGeographicPosition {
  return { height: elevation, latitude: pos.lat, longitude: pos.lng }
}

export function generatePointContent (pos: pinAMapPosition, elevation = 0) {
  const position = getPinPosition(pos, elevation)
  return {
    type: MapElementEnum.PIN,
    content: generatePoint(position, {
      color: MapDoodleColor.PinColor,
      clampToGround: true,
      // Pin posé au sol par défaut : mode explicite persisté. Le Z porté par la coordonnée
      // est en WGS84 ellipsoïdal (= terrain MSL + géoïde, via toAnnotationAltitude) — c'est
      // la référence attendue par la RC/Pilot pour poser le pin au niveau du sol. Ce Z est
      // désormais CONSERVÉ par le backend (car altitudeMode présent = web-managed) ; sans ce
      // drapeau il neutralisait l'altitude → pin enterré à ~-47 m (0 WGS84) sur la RC. Le web,
      // lui, ignore ce Z pour les pins (il affiche l'altitude de SON terrain) → aucun impact.
      altitudeMode: 'ground',
    })
  }
}

function getLieOrPolyPosition (mapPosition: pinAMapPosition[], elevations: number[] = []): MapGeographicPosition[] {
  return mapPosition.map((item, i) => ({
    height: elevations[i] ?? 0,
    latitude: item.lat,
    longitude: item.lng,
  }))
}

export function generateLineContent (mapPosition: pinAMapPosition[], elevations: number[] = []) {
  const position = getLieOrPolyPosition(mapPosition, elevations)
  return {
    type: MapElementEnum.LINE,
    content: generateLine(position, {
      color: MapDoodleColor.PolylineColor,
      directConnected: false,
      clampToGround: true,
    })
  }
}

export function generatePolyContent (mapPosition: pinAMapPosition[], elevations: number[] = []) {
  const position = getLieOrPolyPosition(mapPosition, elevations)
  return {
    type: MapElementEnum.POLY,
    content: generatePolygon(position, {
      color: MapDoodleColor.PolygonColor,
      clampToGround: true,
    })
  }
}

export function generateCircleContent (pos: pinAMapPosition, radius: number, elevation = 0) {
  const position = getPinPosition(pos, elevation)
  return {
    type: MapElementEnum.POLY,
    content: generateCircle(position, { color: MapDoodleColor.PolygonColor, clampToGround: true }, radius)
  }
}
